import React from 'react';
import {
  Box,
  Grid,
  Typography
} from '@mui/material';
import Screenshot from './Screenshot';

const ScreenshotGallery = ({ 
  title, 
  screenshots = [], 
  columns = 2,
  spacing = 2 
}) => {
  if (!screenshots || screenshots.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      {title && (
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500, mb: 2 }}>
          {title}
        </Typography>
      )}
      <Grid container spacing={spacing}>
        {screenshots.map((screenshot, index) => (
          <Grid item xs={12} md={12/columns} key={index}>
            <Screenshot
              src={screenshot.src}
              alt={screenshot.alt}
              caption={screenshot.caption}
              clickable={screenshot.clickable !== false}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ScreenshotGallery;